import React, { useState } from "react";
import img2 from "../imgs/img2.png";
import img3 from "../imgs/img3.png";
import img4 from "../imgs/img4.png";

export default function Header() {
  const [isDownloading, setIsDownloading] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const handleDownload = () => {
    setIsDownloading(true);
    setCountdown(5);

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          // Create a hidden anchor tag to trigger download
          const link = document.createElement('a');
          link.href = 'https://github.com/swapansuvo64/app-releae/releases/download/v1.0.0/application-8cb49961-6a49-44da-8b41-b694a0e2b82a.apk';
          link.download = 'otaku-app.apk';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setIsDownloading(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  return (
    <div className="relative h-auto z-20 flex flex-col  px-4 sm:px-6 md:px-8">
      {/* Top Image */}
      <img
        src={img2}
        alt="Top Image"
        className="w-[70%] mt-3 object-contain z-10 max-w-[300px] sm:max-w-[350px]"
      />

      {/* Wrapper for Bottom Image with Overlay and Text */}
      <div className="relative w-full mt-4">
        {/* Bottom Image */}
        <img
          src={img3}
          alt="Bottom Image"
          className="w-full object-cover rounded-t-[30px] sm:rounded-t-[40px] md:rounded-t-[50px]"
        />

        {/* Text Content */}
        <div className="absolute top-10 left-0 w-full h-full flex flex-col justify-center text-left px-[8%] py-6 sm:py-10 text-white z-20">
          <h1 className="text-[22px] sm:text-[28px] md:text-[35px] font-bold leading-snug sm:leading-tight">
            OTAKU<span className="text-yellow-400">'S</span> - Unleash Your Inner Child – Watch, Read & Dive into the World of Stories!
          </h1>
          <p className="text-[15px] sm:text-[16px] font-bold mt-3">
            Love <span className="font-bold">ANIME</span>? Obsessed with <span className="font-bold">MANGA</span>? 
            OTAKU<span className="text-yellow-400">'S</span> is here—no more endless searching, just pure entertainment right at your fingertips.
          </p>
          <p className="mt-6 text-[15px] sm:text-[16px] font-bold">
            Get ready to open the door to endless new stories, characters, and worlds to explore in one seamless experience.
          </p>

          {/* Download Button as Image */}
          <div className="mt-6 flex flex-col items-center">
            <button 
              onClick={handleDownload}
              disabled={isDownloading}
              className="w-full"
            >
              <img
                src={img4}
                alt="Download Otaku's"
                className="w-[300px] sm:w-[350px] md:w-[400px] mx-auto hover:scale-105 transition-transform duration-300"
              />
            </button>
            
            {isDownloading && (
              <p className="mt-2 text-yellow-400 font-bold">
                Download will start in {countdown} seconds...
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}